import { defineMessages } from 'react-intl'

const scope = `procurify.expense.features.getTravelDetails.TravelDetailsPresenter`

export default defineMessages({
  errorMessage: {
    id: `${scope}.errorMessage`,
    defaultMessage: 'Unable to load this travel request.',
  },
})
